import { render, staticRenderFns } from "./batchListModel.vue?vue&type=template&id=3d585f97"
import script from "./batchListModel.vue?vue&type=script&lang=js"
export * from "./batchListModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d585f97')) {
      api.createRecord('3d585f97', component.options)
    } else {
      api.reload('3d585f97', component.options)
    }
    module.hot.accept("./batchListModel.vue?vue&type=template&id=3d585f97", function () {
      api.rerender('3d585f97', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/policy/homeManage/personnelDetail/batchListModel.vue"
export default component.exports